import { Box, Button, Grid, TextField } from "@mui/material";
import { useState } from "react";
import * as Yup from "yup";
import toastError from "../../../errors/toastError";
import { i18n } from "../../../translate/i18n";

export default function IntegrationHeaderTab({ integrationData, setIntegrationData }) {
    const maxHeaders = 10;
    const initialState = { key: '', value: '' };
    const [header, setHeader] = useState(initialState);

    const CheckHeaderSchema = Yup.object().shape({
        key: Yup.string()
            .required(i18n.t(`integrations.webhook.form.customFields.key.required`))
            .min(2, i18n.t(`integrations.webhook.form.customFields.key.min`)),
        value: Yup.string()
            .required(i18n.t(`integrations.webhook.form.customFields.value.required`))
            .min(1, i18n.t(`integrations.webhook.form.customFields.value.min`)),
    });
    // reordenar para seguir sequencia correta
    if (CheckHeaderSchema['_nodes']) CheckHeaderSchema['_nodes'] = CheckHeaderSchema['_nodes'].reverse();

    const add = async () => {
        // validações
        try {
            await CheckHeaderSchema.validate(header);
        } catch (err) {
            console.error({err});
            toastError({ response: { data: { error: err?.message || 'INTERNAL_ERROR' } } });
            return;
        }

        let headerTmp = Array.isArray(integrationData.headers) ? integrationData.headers : [];
        // verificar se já foi inserido
        if (headerTmp.findIndex((h) => String(h.key) == String(header.key)) != -1) {
            toastError({ response: { data: { error: i18n.t(`integrations.webhook.form.customFields.key.added`) } } });
            return;
        }

        headerTmp.unshift(header);
        setIntegrationData({ ...integrationData, headers: headerTmp });
        setHeader(initialState);
    }

    return (
        <>
            <Grid container spacing={2} style={{ position: "relative" }}>
                <Grid item xs={12} md={5} mb={2}>
                    <TextField
                        margin="dense"
                        id="keyHeader"
                        label={i18n.t(`integrations.webhook.form.customFields.key.title`)}
                        type="text"
                        fullWidth
                        variant="standard"
                        maxLength={50}
                        value={header.key}
                        disabled={integrationData.headers?.length == maxHeaders}
                        onChange={(e) => { setHeader({ ...header, key: e.target.value }) }}
                    />
                </Grid>
                <Grid item xs={12} md={5} mb={2}>
                    <TextField
                        margin="dense"
                        id="valueHeader"
                        label={i18n.t(`integrations.webhook.form.customFields.value.title`)}
                        type="text"
                        fullWidth
                        variant="standard"
                        maxLength={255}
                        value={header.value}
                        disabled={integrationData.headers?.length == maxHeaders}
                        onChange={(e) => { setHeader({ ...header, value: e.target.value }) }}
                    />
                </Grid>
                <Grid item xs={12} md={2} mb={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ width: '100%', top: '22px' }}
                        onClick={() => add()}
                        disabled={integrationData.headers?.length == maxHeaders}
                    >
                        {i18n.t('buttons.add')}
                    </Button>
                </Grid>
            </Grid>
            {
                (Array.isArray(integrationData.headers) && integrationData.headers.length > 0)
                &&
                <Box style={{ marginTop: '15px', paddingBottom: "10px" }}>
                    {integrationData.headers.map((h) => (
                        <Grid container spacing={2} mb={2} style={{ marginBottom: "10px" }} >
                            <Grid item xs={5} style={{ textIndent: '10px' }} >{h.key}</Grid>
                            <Grid item xs={5} >{h.value}</Grid>
                            <Grid item xs={2} style={{ position: 'relative' }}>
                                <Button
                                    variant="contained"
                                    color="error"
                                    style={{ width: '100%' }}
                                    onClick={() => {
                                        let headerTmp = integrationData.headers.filter((hd) => hd.key != h.key);
                                        setIntegrationData({ ...integrationData, headers: headerTmp });
                                    }}
                                >
                                    {i18n.t('buttons.delete')}
                                </Button>
                            </Grid>
                        </Grid>
                    ))}
                </Box>
            }
        </>
    );
}